<!DOCTYPE html>
<html lang="en">

<head>
  <meta charset="utf-8" />
  <meta http-equiv="X-UA-Compatible" content="IE=edge" />
  <meta name="viewport" content="width=device-width, initial-scale=1" />
  <title>403 - Access Denegado</title>
</head>

<body>
  <div class="cover">
    <h1>ACCESO PROHIBIDO</h1>
    <p class="lead"> Usted no cuenta con autorización para esta vista</p>
  </div>

</body>
</html>